import AppRoutes from "./routes/AppRoutes";
import GlobalLoader from "./shared/GlobalLoader";

const App = () => {
  return (
    <>
      <GlobalLoader />
      <AppRoutes />
    </>
  );
};

export default App;
